import React, { useEffect, useState, useRef } from "react";
import ReactFC from "react-fusioncharts";

import FusionCharts from "fusioncharts";
import FusionMaps from "fusioncharts/fusioncharts.maps";

import DataCol from "./dataCol";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
import "./MapsInicial.css";
import { getMapColombia } from "../../services/maps/getMapColombia";
import { getMapDepartment } from "../../services/maps/getMapDepartment";
import { getMapColombiaSostenibilidad } from "../../services/maps/getMapColombiaSostenibilidad";
import { getMapSostenibilidadDepartment } from "../../services/maps/getMapSostenibilidadDepartment";

// Importa todos los mapas de los departamentos
import ColombiaMap from "fusioncharts/maps/fusioncharts.colombia";
import AntioquiaMap from "fusioncharts/maps/fusioncharts.antioquia";
import AraucaMap from "fusioncharts/maps/fusioncharts.arauca";
import AtlanticoMap from "fusioncharts/maps/fusioncharts.atlantico";
import BolivarMap from "fusioncharts/maps/fusioncharts.bolivar";
import BoyacaMap from "fusioncharts/maps/fusioncharts.boyaca";
import CaldasMap from "fusioncharts/maps/fusioncharts.caldas";
import CaquetaMap from "fusioncharts/maps/fusioncharts.caqueta";
import CasanareMap from "fusioncharts/maps/fusioncharts.casanare";
import CaucaMap from "fusioncharts/maps/fusioncharts.cauca";
import CesarMap from "fusioncharts/maps/fusioncharts.cesar";
import ChocoMap from "fusioncharts/maps/fusioncharts.choco";
import CordobaMap from "fusioncharts/maps/fusioncharts.cordoba";
import CundinamarcaMap from "fusioncharts/maps/fusioncharts.cundinamarca";
import GuainiaMap from "fusioncharts/maps/fusioncharts.guainia";
import GuaviareMap from "fusioncharts/maps/fusioncharts.guaviare";
import GuajiraMap from "fusioncharts/maps/fusioncharts.laguajira";
import HuilaMap from "fusioncharts/maps/fusioncharts.huila";
import LaGuajiraMap from "fusioncharts/maps/fusioncharts.laguajira";
import MagdalenaMap from "fusioncharts/maps/fusioncharts.magdalena";
import MetaMap from "fusioncharts/maps/fusioncharts.meta";
import NarinoMap from "fusioncharts/maps/fusioncharts.narino";
import NorteDeSantanderMap from "fusioncharts/maps/fusioncharts.nortedesantander";
import PutumayoMap from "fusioncharts/maps/fusioncharts.putumayo";
import QuindioMap from "fusioncharts/maps/fusioncharts.quindio";
import RisaraldaMap from "fusioncharts/maps/fusioncharts.risaralda";
import SanAndresMap from "fusioncharts/maps/fusioncharts.sanandresprovidenciaandsantacatalina";
import SantanderMap from "fusioncharts/maps/fusioncharts.santander";
import SucreMap from "fusioncharts/maps/fusioncharts.sucre";
import TolimaMap from "fusioncharts/maps/fusioncharts.tolima";
import ValleDelCaucaMap from "fusioncharts/maps/fusioncharts.valledelcauca";
import VaupesMap from "fusioncharts/maps/fusioncharts.vaupes";
import VichadaMap from "fusioncharts/maps/fusioncharts.vichada";
import AmazonasMap from "fusioncharts/maps/fusioncharts.amazonas";

// Registra todos los mapas necesarios
ReactFC.fcRoot(
  FusionCharts,
  FusionMaps,
  ColombiaMap,
  AntioquiaMap,
  AraucaMap,
  AtlanticoMap,
  BolivarMap,
  BoyacaMap,
  CaldasMap,
  CaquetaMap,
  CasanareMap,
  CaucaMap,
  CesarMap,
  ChocoMap,
  CordobaMap,
  CundinamarcaMap,
  GuainiaMap,
  GuaviareMap,
  GuajiraMap,
  HuilaMap,
  LaGuajiraMap,
  MagdalenaMap,
  MetaMap,
  NarinoMap,
  NorteDeSantanderMap,
  PutumayoMap,
  QuindioMap,
  RisaraldaMap,
  SanAndresMap,
  SantanderMap,
  SucreMap,
  TolimaMap,
  ValleDelCaucaMap,
  VaupesMap,
  AmazonasMap,
  VichadaMap,
  FusionTheme
);

const ColombiaMapCombinadoComponent = () => {
  const [mapData, setMapData] = useState(null);
  const [error, setError] = useState(null);
  const [currentMapType, setCurrentMapType] = useState("maps/colombia");
  const [currentDepartmentId, setCurrentDepartmentId] = useState(null);
  const [idMap, setIdMap] = useState({});
  const [nameMap, setNameMap] = useState({});
  const [showBackButton, setShowBackButton] = useState(false);
  const [titleDepto, setTitleDepto] = useState("");
  const [displayedInfo, setDisplayedInfo] = useState(
    "Mueve el cursor sobre un departamento para ver los detalles aquí."
  );
  const [showInfoDiv, setShowInfoDiv] = useState(false);
  const [isHovering, setIsHovering] = useState(false);

  const idMapRef = useRef({});
  const nameMapRef = useRef({});
  const currentDataRef = useRef([]);

  // Flag para controlar el hover durante el click
  const isClickingRef = useRef(false);

  // Referencias para datos combinados
  const paatiDataRef = useRef([]);
  const sostenibilidadDataRef = useRef([]);
  const combinedDataRef = useRef([]);

  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipText, setTooltipText] = useState("");
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setTooltipPosition({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  const handleBackButtonClick = () => {
    setCurrentMapType("maps/colombia");
    setShowInfoDiv(false);
    setDisplayedInfo(
      "Mueve el cursor sobre un departamento para ver los detalles aquí."
    );
  };

  // Función para combinar información de PAATI y SOSTENIBILIDAD
  const combineModuleInfo = (
    paatiInfo,
    sostenibilidadInfo,
    entityName = ""
  ) => {
    let combinedHTML = `
    <div style="
      font-family: Arial, sans-serif;
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
      overflow-x: hidden;
      word-break: break-word;
      display: block;
    ">
  `;

    // Contador de módulos con información
    const hasModules = (paatiInfo ? 1 : 0) + (sostenibilidadInfo ? 1 : 0);

    if (!paatiInfo && !sostenibilidadInfo) {
      combinedHTML += `
        <div style="padding: 20px; text-align: center; color: #666;">
          <p style="font-size: 16px;">⚠️ No hay información disponible para <strong>${entityName || "esta ubicación"
        }</strong></p>
          <p style="font-size: 14px; color: #999;">Este departamento/municipio no está registrado en los módulos PAATI o SOSTENIBILIDAD.</p>
        </div>
      `;
    } else {
      // Mostrar resumen de módulos disponibles
      combinedHTML += `
        <div style="background-color: #fff3cd; padding: 10px; border-radius: 8px; margin-bottom: 15px; border-left: 4px solid #ffc107;">
          <strong>📍 ${entityName || "Ubicación seleccionada"}</strong><br>
          <small style="color: #856404;">
            ${hasModules === 2
          ? "✓ Datos disponibles en PAATI y SOSTENIBILIDAD"
          : paatiInfo
            ? "✓ Datos disponibles en PAATI"
            : "✓ Datos disponibles en SOSTENIBILIDAD"
        }
          </small>
        </div>
      `;

      // Si tiene ambos módulos, mostrar en 2 columnas
      if (paatiInfo && sostenibilidadInfo) {
        combinedHTML += `
         <div style="
  display: flex; 
  flex-wrap: wrap; 
  gap: 15px; 
  width: 100%; 
  max-width: 100%; 
  box-sizing: border-box;
">
  <div style="
    flex: 1 1 0; 
    min-width: 0; 
    max-width: 100%; 
    border: 2px solid #4CAF50; 
    padding: 15px; 
    border-radius: 8px; 
    background-color: #f1f8f4; 
    overflow-wrap: break-word;
  ">
    <h4 style="color: #4CAF50; margin-top: 0; border-bottom: 2px solid #4CAF50; padding-bottom: 10px;">
      📊 PAATI
    </h4>
    ${paatiInfo}
  </div>

  <div style="
    flex: 1 1 0; 
    min-width: 0; 
    max-width: 100%; 
    border: 2px solid #4275af; 
    padding: 15px; 
    border-radius: 8px; 
    background-color: #e3f2fd; 
    overflow-wrap: break-word;
  ">
    <h4 style="color: #4275af; margin-top: 0; border-bottom: 2px solid #4275af; padding-bottom: 10px;">
      🌱 SOSTENIBILIDAD
    </h4>
    ${sostenibilidadInfo}
  </div>
</div>

        `;
      } else if (paatiInfo) {
        // Solo PAATI
        combinedHTML += `
          <div style="border: 2px solid #4CAF50;padding: 4px; border-radius: 8px; background-color: #f1f8f4;">
            <h4 style="color: #4CAF50; margin-top: 0; border-bottom: 2px solid #4CAF50; padding-bottom: 10px;">
              📊 PAATI
            </h4>
            ${paatiInfo}
          </div>
        `;
      } else if (sostenibilidadInfo) {
        // Solo SOSTENIBILIDAD
        combinedHTML += `
          <div style="border: 2px solid #4275af; padding: 4px; border-radius: 8px; background-color: #e3f2fd;">
            <h4 style="color: #4275af; margin-top: 0; border-bottom: 2px solid #4275af; padding-bottom: 10px;">
              🌱 SOSTENIBILIDAD
            </h4>
            ${sostenibilidadInfo}
          </div>
        `;
      }
    }

    combinedHTML += "</div>";
    return combinedHTML;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let resultPaati, resultSostenibilidad;

        if (currentMapType === "maps/colombia") {
          // Obtener datos de ambos módulos para Colombia
          resultPaati = await getMapColombia();
          resultSostenibilidad = await getMapColombiaSostenibilidad();

          // Guardar datos de PAATI
          paatiDataRef.current = resultPaati.data.data;

          // Guardar datos de SOSTENIBILIDAD
          sostenibilidadDataRef.current = resultSostenibilidad.data.data;

          // Crear mapeo de IDs combinando ambos módulos
          const newIdMap = {};
          const newNameMap = {};

          // Agregar IDs de PAATI
          resultPaati.data.data.forEach((item) => {
            newIdMap[item.id] = item.idCodInterno;
            newNameMap[item.id] = item.nameFusion;
          });

          // Agregar IDs de SOSTENIBILIDAD que no estén en PAATI
          resultSostenibilidad.data.data.forEach((item) => {
            if (!newIdMap[item.id]) {
              newIdMap[item.id] = item.idCodInterno;
              newNameMap[item.id] = item.nameFusion;
            }
          });

          idMapRef.current = newIdMap;
          nameMapRef.current = newNameMap;

          // Combinar datos para el mapa (usar colores según módulos)
          const combinedMapData = resultPaati.data.data.map((paatiItem) => {
            const sostenibilidadItem = resultSostenibilidad.data.data.find(
              (item) => item.idCodInterno === paatiItem.idCodInterno
            );

            // Si existe en ambos, color morado
            if (sostenibilidadItem) {
              return {
                ...paatiItem,
                hasPaati: true,
                hasSostenibilidad: true,
                color: "#9C27B0", // Morado para ambos
              };
            }

            // Solo PAATI, color verde
            return {
              ...paatiItem,
              hasPaati: true,
              hasSostenibilidad: false,
              color: "#4CAF50", // Verde para solo PAATI
            };
          });

          // Agregar departamentos que solo están en SOSTENIBILIDAD (color azul)
          resultSostenibilidad.data.data.forEach((sostenibilidadItem) => {
            const existsInPaati = combinedMapData.find(
              (item) => item.idCodInterno === sostenibilidadItem.idCodInterno
            );

            if (!existsInPaati) {
              combinedMapData.push({
                ...sostenibilidadItem,
                hasPaati: false,
                hasSostenibilidad: true,
                color: "#4275af", // Azul para solo SOSTENIBILIDAD
              });
            }
          });

          // CRÍTICO: Asegurar que todos los departamentos tengan el color en el nivel superior
          const departamentosConColor = combinedMapData.map((depto) => ({
            id: depto.id,
            label: depto.label || depto.departamento,
            value: depto.value || "1",
            color: depto.color, // CRÍTICO: campo color
            toolText: depto.toolText || "",
            // Mantener todos los demás datos
            ...depto,
          }));

          currentDataRef.current = departamentosConColor;
          combinedDataRef.current = departamentosConColor;

          setCurrentDepartmentId(null);
          setShowBackButton(false);
          setTitleDepto("");
        } else {
          // Obtener datos de ambos módulos para el departamento
          let municipiosPaati = [];
          let municipiosSostenibilidad = [];

          // Intentar obtener datos de PAATI
          try {
            resultPaati = await getMapDepartment(currentDepartmentId);
            municipiosPaati = resultPaati?.data?.data || [];
          } catch (error) {
            municipiosPaati = [];
          }

          // Intentar obtener datos de SOSTENIBILIDAD
          try {
            resultSostenibilidad = await getMapSostenibilidadDepartment(
              currentDepartmentId
            );
            municipiosSostenibilidad = resultSostenibilidad?.data?.data || [];
          } catch (error) {
            municipiosSostenibilidad = [];
          }

          // Actualizar las referencias
          paatiDataRef.current = municipiosPaati;
          sostenibilidadDataRef.current = municipiosSostenibilidad;

          // Combinar datos de municipios correctamente
          // IMPORTANTE: Usar idCodInterno para hacer el match entre módulos
          const municipiosMap = new Map();

          // Crear un índice por idCodInterno para SOSTENIBILIDAD
          const sostenibilidadByIdCodInterno = new Map();
          municipiosSostenibilidad.forEach((sostMun) => {
            sostenibilidadByIdCodInterno.set(
              sostMun.idCodInterno || sostMun.id,
              sostMun
            );
          });

          // Agregar todos los municipios de PAATI y verificar si también están en SOSTENIBILIDAD
          municipiosPaati.forEach((paatiMun) => {
            const idClave = paatiMun.idCodInterno || paatiMun.id;
            const sostMun = sostenibilidadByIdCodInterno.get(idClave);

            if (sostMun) {
              // Está en AMBOS módulos - MORADO
              municipiosMap.set(paatiMun.id, {
                ...paatiMun,
                hasPaati: true,
                hasSostenibilidad: true,
                paatiData: paatiMun,
                sostenibilidadData: sostMun,
                color: "#9C27B0", // Morado para ambos
              });
              // Marcar como procesado
              sostenibilidadByIdCodInterno.delete(idClave);
            } else {
              // Solo PAATI - VERDE
              municipiosMap.set(paatiMun.id, {
                ...paatiMun,
                hasPaati: true,
                hasSostenibilidad: false,
                paatiData: paatiMun,
                sostenibilidadData: null,
                color: "#4CAF50", // Verde para solo PAATI
              });
            }
          });

          // Agregar municipios que solo están en SOSTENIBILIDAD - AZUL
          sostenibilidadByIdCodInterno.forEach((sostMun) => {
            municipiosMap.set(sostMun.id, {
              ...sostMun,
              hasPaati: false,
              hasSostenibilidad: true,
              paatiData: null,
              sostenibilidadData: sostMun,
              color: "#4275af", // Azul para solo SOSTENIBILIDAD
            });
          });

          // Convertir Map a Array
          const combinedMunicipios = Array.from(municipiosMap.values());

          // CRÍTICO: Asegurar que TODOS los municipios tengan el campo color visible
          const municipiosConColor = combinedMunicipios.map((mun) => {
            // Asegurar que el color esté en el nivel superior del objeto
            const munWithColor = {
              id: mun.id,
              label: mun.label || mun.municipio,
              value: mun.value || "1",
              color: mun.color, // CRÍTICO: campo color
              toolText: mun.toolText || "",
              // Mantener todos los demás datos
              ...mun,
            };
            return munWithColor;
          });

          currentDataRef.current = municipiosConColor;
          combinedDataRef.current = municipiosConColor;

          setShowBackButton(true);
        }

        setMapData({
          type: currentMapType,
          renderAt: "map",
          width: "100%",
          height: "600",
          dataFormat: "json",
          dataSource: {
            chart: {
              caption: "UTF COL 166 - COL",
              subcaption: "PAATI y SOSTENIBILIDAD Combinados",
              theme: "fusion",
              bgColor: "#dee3eb",
              showLabels: "0",
              showlegend: "0",
              borderColor: "#042956",
              borderThickness: "1",
              hoverBorderColor: "#4275af",
              hoverBorderThickness: "1",
              toolTipBorderColor: "#042956",
              toolTipBorderThickness: "1",
              entityFillHoverColor: "#fbc02d",
              entityBorderHoverColor: "#042956",
              toolTipPosition: "bottom",
              animation: "0",
              showToolTip: "0",
              marginTop: "150",
              // CRÍTICO: Permitir colores personalizados
              useSNameInLabels: "0",
              useSNameInToolTip: "0",
            },
            data: currentDataRef.current,
          },
          events: {
            entityRollover: (evt, data) => {
              try {
                // No procesar hover si se está haciendo click
                if (isClickingRef.current) {
                  return;
                }

                setIsHovering(true);
                const entityData = currentDataRef.current.find(
                  (item) => item.id === data.id
                );

                if (entityData) {
                  // Para municipios, usar los datos guardados en el objeto
                  let paatiData = null;
                  let sostenibilidadData = null;

                  if (currentMapType === "maps/colombia") {
                    // A nivel de departamentos
                    paatiData = paatiDataRef.current.find(
                      (item) => item.id === data.id
                    );
                    sostenibilidadData = sostenibilidadDataRef.current.find(
                      (item) => item.id === data.id
                    );
                  } else {
                    // A nivel de municipios - usar los datos almacenados en entityData
                    if (entityData.hasPaati && entityData.paatiData) {
                      paatiData = entityData.paatiData;
                    }
                    if (
                      entityData.hasSostenibilidad &&
                      entityData.sostenibilidadData
                    ) {
                      sostenibilidadData = entityData.sostenibilidadData;
                    }
                  }

                  const entityName =
                    entityData?.municipio ||
                    entityData?.departamento ||
                    data.label;

                  const combinedInfo = combineModuleInfo(
                    paatiData?.detalleText,
                    sostenibilidadData?.detalleText,
                    entityName
                  );

                  setDisplayedInfo(combinedInfo);
                }

                // Mostrar tooltip con el nombre
                const textoTooltip =
                  entityData?.municipio ||
                  entityData?.departamento ||
                  data.label;
                setTooltipText(textoTooltip);
                setShowTooltip(true);

                setShowInfoDiv(true);
              } catch (error) {
                console.error("Error in entityRollover:", error);
              }
            },
            entityRollout: (evt, data) => {
              try {
                setIsHovering(false);
                setShowTooltip(false);

                if (currentMapType === "maps/colombia") {
                  setShowInfoDiv(false);
                }
              } catch (error) {
                console.error("Error in entityRollout:", error);
              }
            },
            entityClick: (eventObj, dataObj) => {
              try {
                // Activar flag de clicking
                isClickingRef.current = true;

                // Desactivar después de un breve delay
                setTimeout(() => {
                  isClickingRef.current = false;
                }, 300);

                handleEntityClick(eventObj, dataObj);
              } catch (error) {
                console.error("Error in entityClick:", error);
              }
            },
          },
        });
      } catch (error) {
        setError("No se pudo cargar la información del mapa");
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [currentMapType, currentDepartmentId]);

  const handleEntityClick = (eventObj, dataObj) => {
    if (currentMapType === "maps/colombia") {
      // Navegar al departamento
      const departmentId = idMapRef.current[dataObj.id];
      const deptoName = nameMapRef.current[dataObj.id];

      // Verificar que existan antes de navegar
      if (!departmentId || !deptoName) {
        return;
      }

      // Obtener información de ambos módulos para el departamento
      const paatiDeptoData = paatiDataRef.current.find(
        (item) => item.id === dataObj.id
      );

      const sostenibilidadDeptoData = sostenibilidadDataRef.current.find(
        (item) => item.id === dataObj.id
      );

      const deptoNameDisplay =
        paatiDeptoData?.nameFusion ||
        sostenibilidadDeptoData?.nameFusion ||
        dataObj.label;

      const combinedInfo = combineModuleInfo(
        paatiDeptoData?.detalleText,
        sostenibilidadDeptoData?.detalleText,
        deptoNameDisplay
      );

      setDisplayedInfo(combinedInfo);
      setShowInfoDiv(true);

      setCurrentDepartmentId(departmentId);
      const mapName = `maps/${deptoName}`;
      setCurrentMapType(mapName);
      setTitleDepto(deptoName.toLowerCase());
      setShowBackButton(true);
    } else {
      // Click en municipio
      const municipioData = currentDataRef.current.find(
        (item) => item.id === dataObj.originalId
      );

      if (municipioData) {
        // Usar los datos almacenados en el objeto municipioData
        const paatiMunData = municipioData.hasPaati
          ? municipioData.paatiData
          : null;
        const sostenibilidadMunData = municipioData.hasSostenibilidad
          ? municipioData.sostenibilidadData
          : null;

        const munNameDisplay =
          paatiMunData?.municipio ||
          sostenibilidadMunData?.municipio ||
          municipioData.municipio ||
          municipioData.label ||
          dataObj.label;

        const combinedInfo = combineModuleInfo(
          paatiMunData?.detalleText,
          sostenibilidadMunData?.detalleText,
          munNameDisplay
        );

        setDisplayedInfo(combinedInfo);
        setShowInfoDiv(true);
        setIsHovering(false);
      } else {
        console.log("No se encontró información para este municipio");
      }
    }
  };

  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  return (
    <div
      className="container-fluid"
      style={{ display: "flex", height: "100vh" }}
    >
      {showBackButton && (
        <button onClick={handleBackButtonClick} className="back-button">
          Volver
        </button>
      )}

      <div className="row" style={{ flex: 1, display: "flex" }}>
        <div
          className="col-md-6"
          style={{ overflowY: "auto", maxHeight: "100vh" }}
        >
          {showInfoDiv ? (
            <div
              id="infoDiv"
              dangerouslySetInnerHTML={{ __html: displayedInfo }}
              style={{
                border: "1px solid #ccc",
                padding: "10px",
                height: "auto",
              }}
            />
          ) : (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                gap: "20px",
                padding: "10px",
                width: "100%",
                maxWidth: "100%",
                boxSizing: "border-box",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  border: "2px solid #4CAF50",
                  borderRadius: "8px",
                  padding: "15px",
                  backgroundColor: "#f1f8f4",
                  minWidth: 0,
                  maxWidth: "100%",
                  overflow: "hidden",
                }}
              >
                <h3
                  style={{
                    color: "#4CAF50",
                    marginTop: 0,
                    borderBottom: "2px solid #4CAF50",
                    paddingBottom: "10px",
                    fontSize: "18px",
                  }}
                >
                  📊 PAATI
                </h3>
                <div style={{ overflowX: "auto", maxWidth: "100%" }}>
                  <DataCol modulo="PAATI" layout="compact" />
                </div>
              </div>

              <div
                style={{
                  border: "2px solid #4275af",
                  borderRadius: "8px",
                  padding: "15px",
                  backgroundColor: "#e3f2fd",
                  minWidth: 0,
                  maxWidth: "100%",
                  overflow: "hidden",
                }}
              >
                <h3
                  style={{
                    color: "#4275af",
                    marginTop: 0,
                    borderBottom: "2px solid #4275af",
                    paddingBottom: "10px",
                    fontSize: "18px",
                  }}
                >
                  🌱 SOSTENIBILIDAD
                </h3>
                <div style={{ overflowX: "auto", maxWidth: "100%" }}>
                  <DataCol modulo="SOSTENIBILIDAD" layout="compact" />
                </div>
              </div>
            </div>
          )}
        </div>
        <div
          className="col-md-6"
          style={{ position: "sticky", top: 0, height: "100vh" }}
        >
          <div id="map" style={{ height: "100%" }}>
            <div className="header-container-depto">
              {titleDepto && (
                <h3 className="header-title">
                  Departamento | {capitalizeFirstLetter(titleDepto)}
                </h3>
              )}
            </div>

            {mapData ? <ReactFC {...mapData} /> : <p>Cargando...</p>}
          </div>
          {showTooltip && (
            <div
              style={{
                position: "fixed",
                top: tooltipPosition.y + 10,
                left: tooltipPosition.x + 10,
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                color: "#fff",
                padding: "6px 10px",
                borderRadius: "6px",
                fontSize: "13px",
                pointerEvents: "none",
                zIndex: 1000,
                whiteSpace: "nowrap",
              }}
            >
              {tooltipText}
            </div>
          )}
        </div>
      </div>

      <div
        id="fixed-tooltip"
        style={{ position: "absolute", pointerEvents: "none" }}
      ></div>
    </div>
  );
};

export default ColombiaMapCombinadoComponent;
